import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle, Phone } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-16 md:py-24 bg-[#1B2E1B] text-white" data-id="element-223">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-225">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C5A55A]/20 text-[#C5A55A] mb-6" data-id="element-226">
            <Gift className="w-8 h-8" data-id="element-227" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-228">THE OFFER</h2>
          <p className="text-xl text-gray-300" data-id="element-229">
            Call us today at{' '}
            <a href="tel:8325034445" className="text-[#C5A55A] font-bold hover:underline" data-id="element-230">
              832-503-4445
            </a>{' '}
            and receive:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl overflow-hidden shadow-2xl text-[#1B2E1B]" data-id="element-231">
          <div className="divide-y divide-gray-100" data-id="element-232">
            <div className="flex items-center justify-between p-6 hover:bg-gray-50 transition-colors" data-id="element-233">
              <span className="font-medium text-lg" data-id="element-234">
                Visual inspection of your lawn
              </span>
              <span className="font-bold text-[#2D5A27] bg-[#2D5A27]/10 px-4 py-1 rounded-full" data-id="element-235">
                FREE
              </span>
            </div>
            <div className="flex items-center justify-between p-6 hover:bg-gray-50 transition-colors" data-id="element-236">
              <span className="font-medium text-lg" data-id="element-237">
                Personalized quote with no obligation
              </span>
              <span className="font-bold text-[#2D5A27] bg-[#2D5A27]/10 px-4 py-1 rounded-full" data-id="element-238">
                FREE
              </span>
            </div>
            <div className="flex items-center justify-between p-6 hover:bg-gray-50 transition-colors" data-id="element-239">
              <span className="font-medium text-lg" data-id="element-240">
                First service with satisfaction guarantee
              </span>
              <div className="flex items-center gap-2 text-[#2D5A27] font-bold" data-id="element-241">
                <CheckCircle className="w-5 h-5" data-id="element-242" />
                <span data-id="element-243">Included</span>
              </div>
            </div>
            <div className="flex items-center justify-between p-6 hover:bg-gray-50 transition-colors" data-id="element-244">
              <span className="font-medium text-lg" data-id="element-245">
                Direct contact with the team
              </span>
              <div className="flex items-center gap-2 text-[#2D5A27] font-bold" data-id="element-246">
                <CheckCircle className="w-5 h-5" data-id="element-247" />
                <span data-id="element-248">Always</span>
              </div>
            </div>
          </div>

          <div className="bg-[#f9f7f2] p-6 text-center border-t border-gray-200" data-id="element-249">
            <p className="font-semibold text-gray-600" data-id="element-250">
              No forced contracts. No price surprises. No excuses.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-251">
          <a href="tel:8325034445" className="inline-flex items-center justify-center gap-2 bg-[#C5A55A] hover:bg-[#b0924e] text-[#1B2E1B] px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:-translate-y-1 shadow-lg" data-id="element-252">
            <Phone className="w-6 h-6" data-id="element-253" />
            Claim This Offer Now
          </a>
        </motion.div>
      </div>
    </section>;
}